var map = {
	"./asian.jpeg": "7327",
	"./breakfast.jpeg": "03c5",
	"./fastfood.jpeg": "fe29",
	"./glutenfree.jpeg": "debe",
	"./healthy.jpeg": "a456",
	"./kosherhalal.jpeg": "328f",
	"./mexican.jpeg": "2294",
	"./pizza.jpeg": "4147",
	"./vegan.jpeg": "c0a3"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b4b0";